import { cssInterop } from "react-native-css-interop";

export function interop(html: Record<string, any>) {
  for (const key in html) {
    if (html.hasOwnProperty(key)) {
      cssInterop(html[key] as any, {
        className: {
          target: "style",
        },
      });
    }
  }
}
